import { RouteNameEnum } from '@/router/RouteName';
import { isRouteNameInRoute, logGuard } from '@/router/helpers';
import { User } from '@/models/User';
import { GlobalUser } from '@/models/GlobalUser';
import ErrorHandler from '@/support/ErrorHandler';
import { Token } from '@/support/Token';
import router from '@/router';
export const authMiddleware = async (to, _from) => {
    logGuard('[AUTH_MIDDLEWARE]', to);
    if (to.query.token) {
        const response = await new GlobalUser().authenticate(to.query.token);
        Token.set({
            access: response.bearer
        });
        const { token, ...queryWithoutToken } = to.query;
        router.replace({
            path: to.path,
            query: queryWithoutToken,
            hash: to.hash,
        });
    }
    const user = await User.attemptLogin()
        .catch((error) => {
        ErrorHandler.network(error);
    });
    if (!user) {
        logGuard('[AUTH_MIDDLEWARE], no user');
        return isRouteNameInRoute(RouteNameEnum.LOGIN, to)
            ? true
            : { name: RouteNameEnum.LOGIN, query: { redirect: to.fullPath } };
    }
    if (!user.hasValidMfa()) {
        logGuard('[AUTH_MIDDLEWARE], no valid mfa');
        return isRouteNameInRoute(RouteNameEnum.SET_MFA, to)
            ? true
            : { name: RouteNameEnum.SET_MFA, query: { redirect: to.fullPath } };
    }
    logGuard('[AUTH_MIDDLEWARE] returning true');
    return true;
};
